import _ from 'lodash';
import React from 'react';

import { getCurrentPageName } from 'common/js/helpers';
import LazyImage from 'webshop/js/lazyimage';
import ProductHelpers from 'webshop/js/product-helpers';
import ProductRowMixin from 'webshop/js/product-row-mixin';

var TireList = React.createClass({
    findCartCount: function(id) {
        var count = 0;
        if (!this.props.cartData) {
            return count;
        }
        var cartRow = _.findWhere(this.props.cartData.rows, {product: id});
        if (cartRow) {
            count = cartRow.count;
        }
        return count;
    },
    createRow: function (product, idx) {
        var cartCount = this.findCartCount(product.id);
        return <TireListBox {...product} key={product.id} cart_count={cartCount} position={idx} />;
    },
    render: function() {
        return <div>{this.props.products && this.props.products.map(this.createRow)}</div>;
    }
});

var TireListBox = React.createClass({
    mixins: [ProductRowMixin],
    render: function () {
        var energyLabel,
            wetGripLabel,
            noiseLevelLabel,
            noiseDBLabel,
            className,
            deliveryTime,
            countAvailable = this.props.stock_total - this.props.cart_count;

        if (this.props.energy_label) {
            className = "eu-label energy-label color-" + this.props.energy_label ;
            energyLabel = <span className={className}>{this.props.energy_label}</span>;
        }
        if (this.props.wet_grip_label) {
            className = "eu-label wet-grip-label color-" + this.props.wet_grip_label ;
            wetGripLabel = <span className={className}>{this.props.wet_grip_label}</span>;
        }
        if (this.props.noise_level) {
            var label_table = ['-', 'A', 'B', 'C'];
            var noise_level_as_label = label_table[this.props.noise_level];
            className = "eu-label noise-level-label color-" + noise_level_as_label;
            noiseLevelLabel = <span className={className}>{noise_level_as_label}</span>;
        }

        if (this.props.noise_dB) {
            noiseDBLabel = <span className="eu-label noise-db-label">{this.props.noise_dB}&nbsp;dB</span>;
        }

        if (this.props.delivery_time) {
          deliveryTime = <div className="delivery-time"><span>Toimitusaika&nbsp;{this.props.delivery_time}</span></div>;
          countAvailable = 1000;
        }

        const tireTypes = {
          'summer': 'Kesärengas',
          'friction': 'Kitkarengas',
          'studded': 'Nastarengas',},
              hasImg = !this.props.thumbnail,
              imgSrc = hasImg ? '/static/nettivanne/webshop/img/rengas.svg' : this.props.thumbnail,
              imgClass = !hasImg ? '' : 'no-pic';
        return (
            <div className="product-box tire">
              <div className="left-container">
                  <div className={'type ' + this.props.tire_type} title={tireTypes[this.props.tire_type]}></div>
                  <div className="img">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                          <LazyImage className={imgClass}
                               alt={this.props.brand + " " + this.props.model + " tuotekuva "}
                               src={imgSrc} />
                        {this.props.near_top && <div className="highlight-product"></div>}
                      </a>
                  </div>
                  <div className="product-name">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                          <div className="brand">{this.props.brand}</div>
                          <div className="model">{this.props.model}{" "}{this.props.title_extra}</div>
                      </a>
                      <div className="details details-mobile">
                          {this.props.width}/{this.props.profile}-{this.props.wheel_size}{" "}
                          {this.props.load_index}{this.props.speed_rating}
                      </div>
                      {deliveryTime}
                      {this.props.width}/{this.props.profile}-{this.props.wheel_size} {this.props.load_index}{this.props.speed_rating}
                      {
                        energyLabel || wetGripLabel || noiseLevelLabel || noiseDBLabel
                        ? <br/>
                        : null
                      }
                      <span className="eu">
                          {energyLabel}
                          {wetGripLabel}
                          {noiseLevelLabel}
                          {noiseDBLabel}
                      </span>
                  </div>
              </div>
              <div className="tire-size">
                  <ProductHelpers.ItemCountControl count={this.state.count}
                                                   unitPrice={this.props.unit_price}
                                                   interval={2}
                                                   max={countAvailable}
                                                   onChange={this.handleCountChange} />
              </div>
              {this.renderAddToCart()}
            </div>
        );
    },
    handleProductClick: function(e) {
        e.preventDefault();
        const tireTypes = {
            'summer': 'Kesärenkaat',
            'friction': 'Kitkarenkaat',
            'studded': 'Nastarenkaat',
            'truck': 'KA',
            'work': 'TK',
            'race': 'Kilparenkaat',
            'other': 'Muut renkaat',
        }
        const urlTarget = this.props.url;
        dataLayer.push({
            'event': 'ecomProductClick',
            'ecommerce': {
              'currencyCode': 'EUR',
              'click': {
                'actionField': {'list': getCurrentPageName()},
                'products': [{
                  'name': this.props.brand + ' ' + this.props.model,
                  'id': this.props.id,
                  'price': this.props.unit_price,
                  'brand': this.props.brand,
                  'category': `${tireTypes[this.props.tire_type]}${this.props.used ? ' käytetyt' : ''}`,
                  'position': this.props.position,
                 }]
               }
             },
             'eventCallback': function() {
               document.location = urlTarget;
             }
        });
    }
});

export default TireList;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-list.js
 **/